import Settings from './setting'
export default Settings
